import { createSlice } from "@reduxjs/toolkit";

import { getAllUsers, searchAllUsers } from "../dispatcher/usersDispatcher";

interface UsersState {
  loading: boolean;
  users: any[];
  user: any;
  loadingAddUser: boolean;
}

const initialState: UsersState = {
  loading: false,
  users: [],
  user: null,
  loadingAddUser: false,
};

// Create a slice for actions and reducers
export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.users;
      })
      .addCase(getAllUsers.rejected, (state) => {
        state.loading = false;
      })
      .addCase(searchAllUsers.pending, (state) => {
        state.loading = false;
      })
      .addCase(searchAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.users;
      })
      .addCase(searchAllUsers.rejected, (state) => {
        state.loading = false;
      });
  },
});

// Export actions
export const {} = usersSlice.actions;

// Export reducer
export default usersSlice.reducer;
